import { IClientAccounts } from '@interfaces/models/client-accounts.interface';
import { createAction, props } from '@ngrx/store';

export const DecedentValidationStart = createAction('[Decedent Security] Validation Start');

export const DecedentValidationSuccess = createAction(
  '[Decedent Security] Validation Success',
  props<{ payload: { valid: boolean } }>(),
);

export const DecedentValidationFailure = createAction('[Decedent Security] Validation Failure');

export const DecedentAccountsSuccess = createAction(
  '[Decedent Security] Accounts Success',
  props<{ payload: { accounts: IClientAccounts } }>(),
);

export const DecedentAccountsFailure = createAction('[Decedent Security] Accounts Failure');
